// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__r8OmK","load3":"Loader_load3__-SA-L"};